/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Skillname1Inputs */

const en_entity_skillname1 = /** @type {(inputs: Entity_Skillname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skill-Name`)
};

const de_entity_skillname1 = /** @type {(inputs: Entity_Skillname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

/**
* | output |
* | --- |
* | "Skill-Name" |
*
* @param {Entity_Skillname1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_skillname1 = /** @type {((inputs?: Entity_Skillname1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Skillname1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_skillname1(inputs)
	return de_entity_skillname1(inputs)
});
export { entity_skillname1 as "entity_skillName" }